/* responsible for project bootstrap and registering `ui` parts */
import bootstrap from '@js/bootstrap';

/* load global locales for moment */
import 'moment/moment';
import 'moment/locale/pl';


import { copyToClipboard } from '@utils/clipboard';

/* polyfill + lazy loading images */
import 'intersection-observer';
import 'lazysizes';
import 'lazysizes/plugins/bgset/ls.bgset';

/* global `ui` parts */
import mustacheContent from '@ui/mustache-content';
import menu from '@ui/menu';
import hiddenBox from '@ui/hidden-box';
import bubbleBox from '@ui/bubble-box';
import submit from '@ui/form/submit';
import loginBar from '@ui/login-bar/index';
import UserModel from 'models/UserModel';
import { siteModel } from 'models/SiteModel';
import storageManager from '@utils/storage-manager';

const ui = [mustacheContent, menu, loginBar, hiddenBox, bubbleBox, submit];
const { register, run } = bootstrap;

const handleBannedUser = () => {
  $('body').addClass('banned');
};

const registerSiteModel = (options) => {
    const {
        paths,
        User,
    } = options;

    const userModel = UserModel.fromJSON(User);

    siteModel.set('paths', paths);
    siteModel.set('User', userModel);

    if (!siteModel.isUserLogged()) {
      return $('body').addClass('fn-anonymous');
    }

    if (userModel.get('areAdditionalSettingsEnabled') && userModel.get('hasDarkMode')) {
        storageManager.setDarkMode('true')
    } else {
        storageManager.setDarkMode('false')
    }

    if (userModel.get('isBanned')) {
      handleBannedUser();
    }
};

const apply = (configuration) => {
    const get = (root, option) => {
        return (configuration[root] || {})[option];
    };
    window.rmpl = { ...window.rmpl, get };
};

/* register global `ui` parts */
register(ui);

/* expose `run` method in namespace */
window.rmpl = { ...window.rmpl, run, registerSiteModel, apply };

window.copyToClipboard = copyToClipboard

/* export used `ui` parts so we can test/debug it */
export { ui };

/* export minimum API we need */
export default { register };



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/core.js